module.exports = __webpack_public_path__ + "media/dashboard/assets/images/berrysupport-onboard-social-d7fcd9e728d5d5ff56c7546db97281e4.svg";